import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetAuditConfig } from 'domain/usecases/reports/get-audit-config';
import { RemoteGetAuditConfig } from 'data/usecases/reports/remote-get-audit-config';

export const makeRemoteGetAuditConfig = (): GetAuditConfig => {
  const auditConfigUrl = `/audit/config`;

  return new RemoteGetAuditConfig(makeApiUrl(auditConfigUrl), makeAuthorizeHttpClientDecorator());
};
